import { DateFilter } from '@starsoft/common/models';
import { UseReferralVoucherMeQueryKey } from './props';
import { ReferralVouchersQueryKeys } from '../../queryKeys';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchReferralVoucherMe } from './service';
import { ReferralVoucherWithStats } from '@/models/referral-voucher/with-stats';
import { PaginatedResponse } from '@/models/pagination/paginated-response.dto';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { usePaginatedQuery } from '@starsoft/common/hooks';

export function useReferralVoucherMe({ endDate, startDate }: DateFilter) {
  const [page, setPage] = useState<number>(1);
  const queryKey: UseReferralVoucherMeQueryKey = [
    ReferralVouchersQueryKeys.Me,
    {
      page,
      limit: 10,
      endDate,
      startDate,
    },
  ];

  const { data, isPending, error, refetch } = useQuery<
    PaginatedResponse<ReferralVoucherWithStats>,
    AxiosError<GenericError>,
    PaginatedResponse<ReferralVoucherWithStats>,
    UseReferralVoucherMeQueryKey
  >({
    queryKey,
    queryFn: fetchReferralVoucherMe,
    staleTime: 5 * 1000,
  });

  const { fetchNextPage, fetchPreviousPage, setCurrentPage } =
    usePaginatedQuery({
      page,
      setPage,
      data,
      queryParams: {
        endDate,
        startDate,
      },
    });

  return {
    error,
    refetch,
    isLoading: isPending,
    fetchNextPage,
    setCurrentPage,
    fetchPreviousPage,
    referralVouchers: data,
    page,
  };
}
